import { mapGetters } from 'vuex';
import { fastContract } from '@/api/modules/product.js';
import heroImage from '@/assets/images/tokenhub/hero-financial-horizon.png';
import HubIcon from './HubIcon.vue';
export default {
  name: 'TokenHub',
  components: {
    HubIcon
  },
  data() {
    return {
      heroImage,
      workflowMode: 'compute',
      workflowTabs: [{
        label: '专属算力服务',
        value: 'compute'
      }, {
        label: 'Token 服务',
        value: 'token'
      }],
      workflowSteps: {
        compute: [{
          title: '业务发起请求',
          description: '内部应用或客户服务场景发起模型调用。'
        }, {
          title: 'Token Hub统一接入',
          description: '完成服务接入、调用管理与持续支持。'
        }, {
          title: '专属算力处理',
          description: '已部署模型在机构专属算力上完成处理。'
        }, {
          title: '结果返回业务',
          description: '处理结果按接入方式返回业务应用。'
        }],
        token: [{
          title: '业务发起请求',
          description: '内部应用或客户服务场景发起模型调用。'
        }, {
          title: 'Token Hub统一接入',
          description: '从统一入口选择并调用所需模型。'
        }, {
          title: '模型按量处理',
          description: '按模型价格和实际用量从余额中扣费。'
        }, {
          title: '结果返回业务',
          description: '处理结果按接入方式返回业务应用。'
        }]
      },
      advantages: [{
        tag: '整机独享',
        title: '专属资源，独立使用',
        description: ['整台机器算力专属使用，不与其他客户共用。', '专属资源，保障数据安全。']
      }, {
        tag: '用量管理',
        title: '按模型用量，统一管理',
        description: ['多个模型共用预付余额，按实际用量计费。', '用量、权限与预算管理，一站式解决。']
      }, {
        tag: '金融场景',
        title: '从真实业务场景，匹配模型',
        description: ['围绕真实业务场景匹配模型。', '结合业务样本评估模型与服务方案。']
      }, {
        tag: '托管服务',
        title: '部署运维，持续支持',
        description: ['承接模型部署、运行维护与服务支持。', '部署与运维全流程服务。']
      }],
      services: [{
        icon: 'server',
        tag: '整机独享 · 全程托管',
        title: '专属算力服务',
        intro: '租用已部署模型的整台机器及全部算力，由我们承接部署与运维。',
        facts: [{
          label: '购买方式',
          value: '选择方案、数量与租期'
        }, {
          label: '费用依据',
          value: '按算力服务方案获取报价'
        }, {
          label: '使用体验',
          value: '直接使用模型服务，无需操作机器'
        }]
      }, {
        icon: 'wallet',
        tag: '按用量消费',
        title: 'Token 模型服务',
        intro: '预付后形成统一余额，多个模型共用。每个模型按自己的价格与实际用量扣费。',
        facts: [{
          label: '购买方式',
          value: '确定意向模型与预算'
        }, {
          label: '费用依据',
          value: '模型单价 × 实际使用量'
        }, {
          label: '使用体验',
          value: '切换模型，继续使用同一个余额'
        }]
      }],
      platformSupport: [{
        title: '方案评估与实施协作',
        description: '围绕业务流程、数据条件和接入要求，梳理实施步骤与验收重点，让机构与服务团队有据协作。',
        points: ['需求与样本梳理', '接入方案评估', '交付与验收协作'],
        visual: ['业务任务', '方案确认', '实施验收']
      }, {
        title: '知识与工具协同',
        description: '按需衔接机构资料、知识检索与业务接口，让模型调用融入现有应用流程。相关能力可按方案组合。',
        points: ['机构资料按需接入', '业务接口衔接', '应用流程组合'],
        visual: ['机构知识', '模型服务', '业务工具']
      }, {
        title: '资源配置与容量规划',
        description: '结合并发、响应要求和模型特点评估算力配置，讨论资源扩展与运行安排，为后续使用做好规划。',
        points: ['业务负载评估', '模型与资源匹配', '扩展需求沟通'],
        visual: ['业务负载', '算力配置', '容量规划']
      }, {
        title: '数据与访问治理',
        description: '围绕数据流转、系统接入与人员访问，确认权限、日志和留存要求，将保护措施落实到具体方案。',
        points: ['数据处理范围', '访问权限与日志', '留存与清理约定'],
        visual: ['访问权限', '日志要求', '数据范围']
      }],
      security: [{
        icon: 'shield',
        title: '数据安全，边界清晰',
        description: '专属算力整机独享，结合机构要求明确数据处理、访问授权与留存范围。'
      }, {
        icon: 'checklist',
        title: '操作留痕，有据可查',
        description: '围绕模型调用与运维操作，明确日志记录和查询范围，便于内部核查与问题追溯。'
      }, {
        icon: 'headset',
        title: '持续运维，服务有保障',
        description: '从容量规划到运行维护，明确监测、异常响应与持续支持安排。'
      }],
      delivery: [{
        title: '沟通业务需求',
        description: '了解业务任务、数据处理要求、使用规模与计划时间，配置不确定也可先讨论。',
        output: '形成需求清单'
      }, {
        title: '确认方案与报价',
        description: '明确模型与资源配置、费用构成、接入方式，以及支持与验收范围。',
        output: '确认服务方案'
      }, {
        title: '准备服务交付',
        description: '按照交付清单完成服务准备，衔接接入与使用，按约定方式核对交付结果。',
        output: '完成交付与验收'
      }, {
        title: '使用与持续支持',
        description: '投入业务使用，按约定提供运行维护与支持，沟通后续变更和服务安排。',
        output: '进入持续服务'
      }],
      business: [{
        number: '01 / 金融能力',
        title: '云端金融能力',
        description: '通过问财接口与场景组件，接入金融对话、查询和资讯解读能力。'
      }, {
        number: '02 / 智能体应用',
        title: '金融智能体应用',
        description: '结合机构本地知识与业务系统，构建对话助手和特色业务智能体。'
      }, {
        number: '03 / APP 智能化',
        title: '证券期货 APP 智能化',
        description: '从场景增强到 AI 服务专区，按机构建设目标，规划不同深度的智能化方案。'
      }],
      faq: [{
        question: '还没确定模型或算力配置，可以先咨询吗？',
        answer: '可以。先描述业务用途、使用规模和计划时间，再结合需求讨论方案与报价。'
      }, {
        question: '租用专属算力，会获得固定数量的 Token 吗？',
        answer: '专属算力提供对应机器的算力使用权，不预设固定赠送 Token 数量。实际产出取决于模型、配置和使用情况，可在方案评估中讨论性能需求。'
      }]
    };
  },
  computed: {
    ...mapGetters(['haslogin']),
    activeWorkflowSteps() {
      return this.workflowSteps[this.workflowMode];
    }
  },
  methods: {
    handleAppointment() {
      const h = this.$createElement;
      if (this.haslogin) {
        fastContract({
          source: '官网',
          product_name: this.$route.meta.title
        }).then(res => {
          if (res.code === 1) {
            this.$success({
              title: '预约成功',
              content: h("div", [h("p", ["\u60A8\u7684\u7533\u8BF7\u5DF2\u63D0\u4EA4\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u548C\u60A8\u8054\u7CFB\uFF01"]), h("p", ["\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BF9\u63A5\u7684\u540C\u82B1\u987A\u9500\u552E\u540C\u4E8B\u6216\u81F4\u75350571-88911818"])])
            });
          }
        });
      } else {
        this.$confirm({
          title: '您还没有登录，请点击前往登录',
          onOk: () => {
            this.$router.replace({
              path: '/login'
            });
          },
          centered: true
        });
      }
    },
    handleTabKeydown(event, index) {
      const keyOffsets = {
        ArrowLeft: -1,
        ArrowRight: 1
      };
      let nextIndex = index;
      if (keyOffsets[event.key]) nextIndex = (index + keyOffsets[event.key] + this.workflowTabs.length) % this.workflowTabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.workflowTabs.length - 1;
      if (nextIndex === index) return;
      event.preventDefault();
      this.workflowMode = this.workflowTabs[nextIndex].value;
      this.$nextTick(() => document.getElementById(`workflow-tab-${this.workflowMode}`).focus());
    }
  }
};